import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";
import SingleSelectDropDown from "../../../../layouts/SingleSelectDropDown";
import { ReasonForCancelPayment } from "../../../../utils/constant";
import { toast } from "react-toastify";

const CancelPaymentModal = ({
  id,
  otherSubmissionFunc,
  changeCancelReason,
  cancelReason,
  closeCancelPaymentModal,
}) => {
  const ref = useRef();
  useEffect(() => {
    return modalEventListener(ref, closeCancelPaymentModal);
  }, [closeCancelPaymentModal]);

  const otherSubmit = (e) => {
    if (!cancelReason) {
      toast.dismiss();
      return toast.error("Please select cancellation Reason", {
        theme: "colored",
      });
    }
    otherSubmissionFunc("submit", 3, 10, "dtStage3");
    closeCancelPaymentModal();
  };
  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="cancel-payment-modal-content" ref={ref}>
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={closeCancelPaymentModal}
          >
            <span>&times;</span>
          </button>
          <h4 className="modal-title" id="cancelPaymentModal">
            Reason For Cancellation
          </h4>
        </div>
        <div className="modal-body clearfix">
          <SingleSelectDropDown
            dataArr={ReasonForCancelPayment}
            handleChange={changeCancelReason}
            name={`cancel_reason${id}`}
            divClassName="form-group mrg-T15"
            value={cancelReason}
          />
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn rc-btn_primary pad-L20 pad-R20"
            onClick={otherSubmit}
          >
            Done
          </button>
          <button
            type="button"
            className="btn rc-btn_rset pad-L20 pad-R20"
            onClick={closeCancelPaymentModal}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default CancelPaymentModal;
